import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { activeLanguage, getLanguage } from '../config/languages';

const SEO = ({
  title: titleProp,
  description: descriptionProp,
  keywords: keywordsProp,
  canonical = "https://www.runvya.com",
  ogImage = "https://www.runvya.com/og-image.png",
  type = "website",
  noindex = false
}) => {
  const { t, i18n } = useTranslation();
  const title = titleProp || t('landing.seo.defaultTitle');
  const description = descriptionProp || t('landing.seo.defaultDescription');
  const keywords = keywordsProp || t('landing.seo.defaultKeywords');
  const ogLocale = getLanguage(activeLanguage(i18n)).intl.replace('-', '_');
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:site_name" content="Runvya ERP" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={title} />

      {/* Canonical */}
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export default SEO;
